// extracted by mini-css-extract-plugin
export default {"hover":"modals_hover__KV8kX"};